import React, { Fragment } from 'react';

function AccountInfoItem({ label, name, value, isEditing, temporaryValue, handleInputChange }) {
  return (
    <div className="account__info-item">
      {isEditing ? (
        <Fragment>
          <label htmlFor={`${name}-input`} className="account__info-label">
            {label}
          </label>
          <input
            type="text"
            name={name}
            id={`${name}-input`}
            value={temporaryValue || value || ''}
            onChange={handleInputChange}
          />
        </Fragment>
      ) : (
        <dl>
          <dt className="account__info-label">
            {label}
          </dt>
          <dd>
            {value || 'N/A'}
          </dd>
        </dl>
      )}
    </div>
  );
}

export default AccountInfoItem;



// WEBPACK FOOTER //
// ./src/components/features/account/AccountInfoItem.js